module.exports = __webpack_public_path__ + "static/media/incu-2.23920e83.jpg";